/* eslint-disable import/prefer-default-export */

export const isProd = () => {
  return window.location.hostname === "connect.petal.org";
};
